export default {
  url: 'https://kenziebottoms-c396.restdb.io/rest',
  key: '5a946ab3696ea8f017645933',
}
